import { Component, ContentChildren, EventEmitter, Input, Output, QueryList, TemplateRef, ViewChild } from '@angular/core';

@Component( {
  selector: 'qm-tab[headerTitle]',
  template: `
  <ng-template>
    <ng-content></ng-content>
  </ng-template>
  `
})
export class QmTabComponent {

  @Input()
  headerTitle: string = "";

  @Input()
  selectedTab: boolean = false;

  @Input()
  disabled: boolean = false;

  @ViewChild(TemplateRef, { static: true }) templateRef!: TemplateRef<void>;
}


@Component({
  selector: 'qm-tabview',
  template: `
    <p-tabView [(activeIndex)]="tabIndex" (onChange)="changeEvent.emit($event)">
      <ng-container *ngFor="let tc of tabContents">
        <p-tabPanel [header]="tc.headerTitle" [selected]="tc.selectedTab" [disabled]="tc.disabled">
          <ng-container *ngTemplateOutlet="tc.templateRef"> </ng-container>
        </p-tabPanel>
      </ng-container>
    </p-tabView>
  `,
  styleUrls: ['./qm-tabview.component.css'],
})
export class QmTabviewComponent {

  @Input()
  tabIndex : number = 0;

  @Output()
  changeEvent = new EventEmitter<any>();

  @ContentChildren(QmTabComponent, { descendants: true }) tabContents!: QueryList<QmTabComponent>;

}
